export default __webpack_public_path__ + "static/media/add.0a53e6f3.svg";